import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import ProgessTitle from '../components/ProgessTitle';
import Sponsors from '../components/Sponsors';

const ConfirmationPage = (props) => {
  const [info, setInfo] = useState([]);
  const [content, setContent] = useState([]);

  const getBanner = () => {
    switch (info.tour) {
      case 'coffee':
        return <Banner id={60} city="coffee" lineBottom={'line'} thumb="logo_adventures.png"/>;
      case 'volcano':
        return <Banner id={61} city="volcano" lineBottom={'line'} thumb="logo_adventures.png"/>;
      case 'antioquia':
        return <Banner id={64} city="antioquia" lineBottom={'line'} thumb="logo_adventures.png"/>;
      default:
        return <Banner id={60} city="coffee" lineBottom={'line'} thumb="logo_adventures.png"/>;
    }
  }

  useEffect(() => {
    const session = sessionStorage.getItem('la-leyenda-adventures');
    const data = JSON.parse(session);
    setInfo(data);
    sessionStorage.clear();

    fetch(`${process.env.REACT_APP_URL}/api/adventures/general/adventures/confirmation-page`)
    .then(res => res.json())
    .then(
      (res) => {
        setContent(res.content);
      },
      (error) => {
        setContent(error);
      }
    )
  }, []);

  return (
    <Layout>
      {getBanner()}
      <ProgessTitle
        step3="active"
        tour={info.tour}
      />
      <div className="row ConfirmationPage">
        <div className="container">
          {ReactHtmlParser(content.content_es)}
        </div>
      </div>
      <Sponsors
        items={[]}
        city={info.tour}
      />
    </Layout>
  );
};

export default ConfirmationPage;
